import React from 'react';
import { Formik, ErrorMessage } from 'formik';

import LoadMask from 'components/LoadMask';
import BasicButtonGroup from 'components/BasicButtonGroup';
import BasicButton from 'components/BasicButton';
import BasicSubmitButton from 'components/BasicSubmitButton';
import BasicInput from 'components/BasicInput';
import LinkButton from '../../../../components/LinkButton';
import { ValidationSchema } from './validate';

import { CSSTransition } from 'react-transition-group';
import { ANIMATION_TIMEOUT_APPEAR } from 'constants/animation.js';

import './styles.css';

const AccountSettingsChangeEmailForm = props => {
  const { proceed, dismiss } = props.actions;
  const { email } = props.params;

  const onSubmit = (values, { setSubmitting }) => {
    setSubmitting(false)
    proceed({
      ...values,
    });
  };

  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames="fade"
    >
      <div className="form__inner">
        <Formik
          initialValues={{
            email: email,
          }}
          validationSchema={ValidationSchema}
          onSubmit={onSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit} className="form__content">
              {isSubmitting && <LoadMask />}
              <div className="form__group form__group--compact">
                <BasicInput
                  label="Email"
                  required={true}
                  name="email"
                  inputType="email"
                  content={values.email}
                  placeholder="Email..."
                  controlFunc={handleChange}
                  isValid={(!errors.email && touched.email) || !touched.email}
                  touchFunc={handleBlur}
                  labelStyles={{ fontWeight: 'bold' }}
                />

                <ErrorMessage
                  name="email"
                  render={message => (
                    <div className="form__error">{message}</div>
                  )}
                />
              </div>
              <div className="form__controls form__controls--compact form__controls--center">
                <BasicButtonGroup
                  groupStyles={{ width: '100%', justifyContent: 'center' }}
                >
                  <BasicSubmitButton
                    controlFunc={handleSubmit}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnArrow={true}
                    btnTextColor="#27282d"
                    btnText="Save"
                  />

                  <BasicButton
                    controlFunc={dismiss}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnArrow={false}
                    btnTextColor="#27282d"
                    btnText="Cancel"
                  />
                </BasicButtonGroup>
                <LinkButton text={'Reset to default'} controlFunc={() => {
                  proceed({email: ''});
                }} />
              </div>
            </form>
          )}
        </Formik>
      </div>
    </CSSTransition>
  );
};

export default AccountSettingsChangeEmailForm;
